import { gql } from '@apollo/client';

const CREATE_CLIENT = gql`
  mutation CreateClient($clientInput: ClientInput!) {
    createClient(clientInput: $clientInput) {
      __typename
      ... on CreateClientSuccess {
        code
        client {
          id
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;

const GET_CLIENT_ID = gql`
  query GetClient($email: String) {
    getClient(email: $email) {
      __typename
      ... on Error {
        message
        code
      }
      ... on GetClientSuccess {
        code
        client {
          id
        }
      }
    }
  }
`;

const GET_DEVOULUTION_PAGE_DATA = gql`
  query GetDevolutionPageDataWOAuth($storeId: ID!) {
    devolutionPageConfigs: getDevolutionPageConfigsWOAuth(storeId: $storeId) {
      __typename
      ... on GetDevolutionPageConfigsSuccess {
        code
        configs {
          backgroundColor
          headerFooterColor
          primaryColor
          secondaryColor
          fontColor
          fontColorSecondary
          footerIconsColor
          fontFamily
          logoUrl
          faviconUrl
          mainImageUrl
          mainImageMobileUrl
          instagramAccount
          facebookAccount
          linkedinAccount
          tiktokAccount
          contactEmail
          link1Title
          link1Url
          link2Title
          link2Url
          mainImageSizingMode
          mainImageMobileSizingMode
        }
      }
      ... on Error {
        code
        message
      }
    }
    storeConfigs: getStoreConfigs(storeId: $storeId) {
      __typename
      ... on GetStoreConfigsSuccess {
        code
        storeConfigs {
          autoApproveDevolution
          considerDevolutionItems
          enableVtexItemsSearch
          showCountdownScreen
          enableOrderNumberInput
          enableMemphisOrderInfoSearch
        }
      }
      ... on Error {
        code
        message
      }
    }
    itemCategories: getEligibleCategoriesWOAuth(encStoreId: $storeId) {
      __typename
      ... on GetEligibleCategoriesSuccess {
        code
        orderItemCategories {
          id
          name
          eligible
        }
      }
      ... on Error {
        code
        message
      }
    }
    itemReasons: getReturnReasonsByStoreWOAuth(encStoreId: $storeId) {
      ... on GetReturnReasonsByStoreSuccess {
        code
        returnReasons {
          id
          description
          isSelected
        }
      }
      ... on Error {
        code
        message
      }
    }
    integrationStatus: getIntegrationsStatus(storeId: $storeId) {
      __typename
      ... on GetIntegrationsStatusSuccess {
        code
        status {
          correios
          cliqueRetire
          vtex
          memphis
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;

const GET_VTEX_ORDER_INFO = gql`
  query GetVtexOrderInfo($encStoreId: ID!, $vtexOrderNumber: String!) {
    getVtexOrderInfo(
      encStoreId: $encStoreId
      vtexOrderNumber: $vtexOrderNumber
    ) {
      ... on GetVtexOrderItemsSuccess {
        code
        items {
          uniqueId
          name
          price
          quantity
          imageUrl
          invoiceKey
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const SAVE_ORDER_WO_AUTH = gql`
  mutation SaveOrderWOAuth($encStoreId: ID!, $orderInput: OrderInput!) {
    saveOrderWOAuth(encStoreId: $encStoreId, orderInput: $orderInput) {
      __typename
      ... on SaveOrderSuccess {
        code
        orderId
        selectReturnLocationUrl
      }
      ... on Error {
        message
        code
      }
    }
  }
`;

const SET_CR_RETURN_METHOD = gql`
  mutation SetCliqueRetireReturnMethod($encOrderId: ID!, $boxCode: String!) {
    setCliqueRetireReturnMethod(encOrderId: $encOrderId, boxCode: $boxCode) {
      __typename
      ... on SetCliqueRetireReturnMethodSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const SET_CORREIOS_RETURN_METHOD = gql`
  mutation SetCorreiosReturnMethod($encOrderId: ID!) {
    setCorreiosReturnMethod(encOrderId: $encOrderId) {
      __typename
      ... on SetCorreiosReturnMethodSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const APPROVE_OR_REJECT_ORDER = gql`
  mutation ApproveOrRejectOrder($orderId: ID!, $choice: Boolean!) {
    approveOrRejectOrder(orderId: $orderId, choice: $choice) {
      ... on ApproveOrRejectOrderSuccess {
        code
        message
        data {
          ... on ApprovedCliqueRetireOrderInfo {
            expressNumber
            qrCodeUrl
            selectedLockerAddress
          }
          ... on ApprovedCorreiosOrderInfo {
            correiosPostageNumber
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_STORE_ID_BY_STORE_NAME_ID = gql`
  query GetStoreByStoreNameId($storeNameId: ID!) {
    getStoreByStoreNameId(storeNameId: $storeNameId) {
      ... on GetStoreByStoreNameIdSuccess {
        code
        store {
          id
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_MEMPHIS_ORDER_INFO = gql`
  query GetMemphisOrderInfo($storeId: ID!, $orderNumber: String!) {
    getMemphisOrderInfo(storeId: $storeId, orderNumber: $orderNumber) {
      ... on GetMemphisOrderInfoSuccess {
        code
        info {
          eTicket
          trackingCode
          clientName
          clientEmail
          clientPhone
          expirationDate
          memphisOrderId
          itemQuantity
          itemDescription
          itemTotalValue
          cpfCnpj
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const CREATE_ORDER_WITH_CLIENT_INFO = gql`
  mutation CreateOrderWithClientInfo(
    $storeId: ID!
    $order: OrderInputWithClient!
  ) {
    createOrderWithClientInfo(storeId: $storeId, order: $order) {
      ... on SaveOrderSuccess {
        code
        orderId
        selectReturnLocationUrl
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_ORDER_LINK = gql`
  query GetOrderLink($externalOrderCode: ID!, $storeId: ID!) {
    getOrderLink(externalOrderCode: $externalOrderCode, storeId: $storeId) {
      ... on GetOrderLinkSuccess {
        code
        link
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

export default {
  CREATE_CLIENT,
  GET_CLIENT_ID,
  GET_DEVOULUTION_PAGE_DATA,
  GET_VTEX_ORDER_INFO,
  SAVE_ORDER_WO_AUTH,
  SET_CR_RETURN_METHOD,
  SET_CORREIOS_RETURN_METHOD,
  APPROVE_OR_REJECT_ORDER,
  GET_STORE_ID_BY_STORE_NAME_ID,
  GET_MEMPHIS_ORDER_INFO,
  CREATE_ORDER_WITH_CLIENT_INFO,
  GET_ORDER_LINK,
};
